import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = { class: "chart-row" }
const _hoisted_3 = { class: "chart-wrapper" }
const _hoisted_4 = { class: "scrollable-chart-container" }
const _hoisted_5 = { class: "pt-4" }
const _hoisted_6 = { class: "analysis-info" }
const _hoisted_7 = { class: "analysis-date" }
const _hoisted_8 = { class: "analysis-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WeightPicker = _resolveComponent("WeightPicker")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Chart, {
              type: "line",
              data: _ctx.chartData,
              options: _ctx.chartOptions,
              height: "200px",
              class: "chart"
            }, null, 8, ["data", "options"])
          ])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "ps-2 pe-2 pe-0 py-2 mt-2 blocktext",
      style: {"border-left":"10px solid #4caf50"}
    }, " За последнюю неделю вы достигли впечатляющих результатов, масса тела уменьшилась на 10%. Продолжайте соблюдать рекомендации по питанию и высокий уровень физической активности. ", -1)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DataTable, {
        value: _ctx.analyses,
        tableStyle: "min-width: 100%",
        class: "analysis-table",
        showHeader: false,
        showGridlines: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "История показателей" }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(data.date) + " ", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                  color: data.ves > data.ves_b ? '#dc3545' : '#20c997',
                })
                  }, _toDisplayString(data.ves_b
                    ? data.ves > data.ves_b
                      ? " ▲"
                      : data.ves_b == data.ves
                      ? ""
                      : " ▼"
                    : ""), 5)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, "Масса тела: " + _toDisplayString(data.ves), 1),
                  _createElementVNode("span", null, "ИМТ: " + _toDisplayString(data.imt), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { class: "w-24 !text-end" }, {
            body: _withCtx(() => [
              _createElementVNode("div", {
                class: "expand-icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewresult = true))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
              ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("button", {
      class: "floating-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibleBottom = true))
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "pi pi-plus" }, null, -1)
    ])),
    _createVNode(_component_Drawer, {
      visible: _ctx.visibleBottom,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visibleBottom) = $event)),
      header: "Добавить измерение",
      position: "bottom",
      class: "drawer-weight"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_WeightPicker, {
          initialWeight: _ctx.analyses[0]?.ves || _ctx.getLastWeightFromStorage() || 70,
          maxWeight: 200,
          step: 0.1,
          viewportWidth: 250,
          modelValue: _ctx.selectedWeight,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedWeight) = $event)),
          onSave: _ctx.onWeightChange
        }, null, 8, ["initialWeight", "modelValue", "onSave"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}